import { render, staticRenderFns } from "./TodoUpdateSidebar.vue?vue&type=template&id=ecb4ebe4&scoped=true&"
import script from "./TodoUpdateSidebar.vue?vue&type=script&lang=js&"
export * from "./TodoUpdateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./TodoUpdateSidebar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TodoUpdateSidebar.vue?vue&type=style&index=1&id=ecb4ebe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb4ebe4",
  null
  
)

export default component.exports